import Events from "./events.service";

const eventsModule = angular
  .module("app.services.events", [])
  .service("Events", Events);

export default eventsModule;



// WEBPACK FOOTER //
// ./src/services/events/events.module.js